import React from 'react';
import { styled } from '@mui/material';
import { ConfirmationDialog } from 'components/ConfirmationDialog/ConfirmationDialog';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

export interface CareProgramRequestDeclinedDialogProps {
  open: boolean;
  onClose: () => void;
}

const StyledDeclinedDialog = styled(ConfirmationDialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: 232,
    maxWidth: 232,
    minHeight: 173,
    borderRadius: '2px',
    margin: 0,
    [theme.breakpoints.up('sm')]: {
      width: 364,
      maxWidth: 364,
      minHeight: 256,
      borderRadius: '2.6px',
    },
  },
  '& .MuiDialogTitle-root': {
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: '20px',
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(3.75),
      paddingLeft: theme.spacing(3.75),
      fontSize: '26px',
    },
  },
  '& .MuiDialogContent-root': {
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(0.75),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3.75),
      paddingBottom: theme.spacing(3),
    },
  },
  '& .MuiDialogContentText-root': {
    paddingBottom: 0,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '16px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '20.8px',
    },
  },
}));

export const CareProgramRequestDeclinedDialog = ({
  open,
  onClose,
}: CareProgramRequestDeclinedDialogProps) => {
  const { translation } = useTranslationContext();
  // TO-DO Translation Ticket WFMOB-16338
  return (
    <StyledDeclinedDialog
      open={open}
      onClose={onClose}
      className="care-program-request-declined-dialog"
      title="Program request was declined"
      description="Message your care team to confirm your health goals."
      noButtonLabel={undefined}
      yesButtonLabel={translation('general_ok')}
      handleNo={onClose}
      handleYes={onClose}
    />
  );
};
